export function AppointmentIndicator({
  hasAppointments,
}: {
  hasAppointments: boolean;
}) {
  return (
    <i
      aria-hidden="true"
      className={`appointment-indicator${hasAppointments ? " has-appointments" : ""}`}
    />
  );
}
